import React, { useState } from 'react'

import './styles.css'
import { useNavigate } from 'react-router-dom'
import Copyright from 'src/common/components/Copyright'
import { Button } from '@mui/material'
import Logo from 'src/common/logo'

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <div className='login-page column'>
      <div className='logo'>
        <Logo />
      </div>
      <p
        className='gradient-text'
        style={{
          fontFamily: 'Satoshi',
          color: '#ffffff',
          fontSize: '256px',
          fontWeight: '500',
          marginTop: '40px'
        }}
      >
        404
      </p>
      <p
        style={{
          fontFamily: 'Satoshi',
          fontSize: '24px',
          color: '#6858D9'
        }}
      >
        Oops, this page not found!
      </p>

      <Button
        sx={{
          color: '#6858D9',
          background: '#6858D91A',
          textTransform: 'none',
          mt: '24px',
          borderRadius: '12px',
          padding: '8px 40px'
        }}
        onClick={() => navigate('/')}
      >
        Go to Dashboard
      </Button>
      <div className='spacer'></div>
      <Copyright />
    </div>
  )
}

export default NotFoundPage
